var _defs, _polygon, _polygon2, _polygon3, _line, _polyline, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypePartComponent48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    "data-name": "New Gradient Swatch 1",
    x1: 14.4997,
    y1: 4.6406,
    x2: 32.5003,
    y2: 22.6412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cde6eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2214,
    stopColor: "#c6e2e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5419,
    stopColor: "#b3d8e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9212,
    stopColor: "#93c7d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8cc3d2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2",
    "data-name": "New Gradient Swatch 2",
    x1: 2.218,
    y1: 16.9223,
    x2: 26.782,
    y2: 41.4864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afd7e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1588,
    stopColor: "#a4d0dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7059,
    stopColor: "#80bcce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73b4c8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-2",
    x1: 18.3811,
    y1: 29.169,
    x2: 28.6189,
    y2: 39.4068,
    xlinkHref: "#New_Gradient_Swatch_2"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "23.5 24.05 41.5 13.641 41.5 34.36 23.5 44.768 23.5 24.05",
    fill: "#3c91af"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "5.5 13.64 23.47 3.232 41.5 13.641 23.5 24.05 5.5 13.64",
    fill: "url(#New_Gradient_Swatch_1)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "23.5 24.05 23.5 44.768 5.5 34.359 5.5 13.64 23.5 24.05",
    fill: "url(#New_Gradient_Swatch_2)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23.5,
    y1: 24.0501,
    x2: 23.5,
    y2: 44.5257,
    stroke: "#147391",
    strokeLinejoin: "round",
    fill: "url(#New_Gradient_Swatch_2-2)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "41.5 13.641 23.5 24.05 5.5 13.64",
    fill: "none",
    stroke: "#147391",
    strokeLinejoin: "round"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "23.47 3.232 5.5 13.64 5.5 34.359 23.5 44.768 41.5 34.36 41.5 13.641 23.47 3.232",
    fill: "none",
    stroke: "#464646",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypePartComponent48);
export default __webpack_public_path__ + "static/media/typePartComponent48.6cd662c554d5f8e9cfc23ad8c465599b.svg";
export { ForwardRef as ReactComponent };